export enum LoginSsoErrorTypes {
  AccessDenied = 'access_denied',
  OauthFailed = 'oauth_failed',
  OtherErrors = 'other_errors',
}
